import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/thanks/questions-back.webp";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Questioncta() {
  return (
    <section className="question_cta p-100 text_white">
      <Container>
        <div
          className="question-cta-box"
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Row>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
              <h4 style={{ color: "#f47a14" }}>If you have any questions</h4>
              <p>Feel free to reach out to us at</p>
              <div className="email-box">
                <div className="email-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="17"
                    fill="none"
                    viewBox="0 0 21 17"
                  >
                    <path
                      fill="#F47A1F"
                      d="M2.549 16.797c-.55 0-1.021-.196-1.413-.588a1.926 1.926 0 01-.587-1.412v-12c0-.55.196-1.021.587-1.413A1.926 1.926 0 012.55.797h16c.55 0 1.02.196 1.412.587.392.392.588.863.588 1.413v12c0 .55-.196 1.02-.588 1.412a1.926 1.926 0 01-1.412.588h-16zm8-7l8-5v-2l-8 5-8-5v2l8 5z"
                    ></path>
                  </svg>
                </div>
                <div className="email-content">
                  <Link
                    to="mailto:info@tekrevol.com"
                    aria-label="TekRevol Contact"
                  >
                    info@tekrevol.com
                  </Link>
                </div>
              </div>
              <p>or call us at</p>
              <div className="email-box">
                <div className="email-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="23"
                    height="15"
                    fill="none"
                    viewBox="0 0 23 15"
                  >
                    <g clipPath="url(#clip0_4084_3921)">
                      <path fill="#fff" d="M.154.125h22v14h-22v-14z"></path>
                      <path
                        fill="#D80027"
                        d="M.154.125h22v1.077h-22V.125zm0 2.153h22v1.077h-22V2.278zm0 2.153h22v1.077h-22V4.431zm0 2.154h22V7.66h-22V6.585zm0 2.157h22v1.077h-22V8.742zm0 2.153h22v1.077h-22v-1.077zm0 2.153h22v1.077h-22v-1.077z"
                      ></path>
                      <path
                        fill="#2E52B2"
                        d="M.154.125h11v7.536h-11V.125z"
                      ></path>
                      <path
                        fill="#fff"
                        d="M2.204 5.815l-.172-.524-.189.524h-.566l.46.316-.172.524.467-.324.455.324-.176-.524.467-.316h-.574zm2.414 0l-.176-.524-.18.524h-.566l.459.316-.172.524.46-.324.462.324-.171-.524.459-.316h-.575zm2.423 0l-.184-.524-.172.524h-.579l.472.316-.18.524.459-.324.471.324-.18-.524.46-.316H7.04zm2.41 0l-.171-.524-.18.524h-.57l.462.316-.171.524.459-.324.463.324-.185-.524.472-.316h-.579zM4.442 3.212l-.18.524h-.566l.459.323-.172.516.46-.32.462.32-.171-.516.459-.323h-.575l-.176-.524zm-2.41 0l-.189.524h-.566l.46.323-.172.516.467-.32.455.32-.176-.516.467-.323h-.574l-.172-.524zm4.825 0l-.172.524h-.579l.472.323-.18.516.459-.32.471.32-.18-.516.46-.323H7.04l-.184-.524zm2.423 0l-.18.524h-.57l.462.323-.171.516.459-.32.463.32-.185-.516.472-.323h-.579l-.171-.524zM2.032 1.141l-.189.515h-.566l.46.324-.172.52.467-.324.455.324-.176-.52.467-.324h-.574l-.172-.515zm2.41 0l-.18.515h-.566l.459.324-.172.52.46-.324.462.324-.171-.52.459-.324h-.575l-.176-.515zm2.415 0l-.172.515h-.579l.472.324-.18.52.459-.324.471.324-.18-.52.46-.324H7.04l-.184-.515zm2.423 0l-.18.515h-.57l.462.324-.171.52.459-.324.463.324-.185-.52.472-.324h-.579l-.171-.515z"
                      ></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_4084_3921">
                        <path
                          fill="#fff"
                          d="M0 0H22V14H0z"
                          transform="translate(.154 .125)"
                        ></path>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className="email-content">
                  <Link to="tel:+18003629239" aria-label="TekRevol Contact">
                    +1 800-362-9239
                  </Link>
                </div>
              </div>
              <p>We look forward to building something amazing together!</p>
            </Col>
            <Col
              xs={12}
              md={6}
              lg={6}
              xl={6}
              xxl={6}
              className="text-center mt-3 mt-md-0"
            >
              <StaticImage
                src="../../images/thanks/question-laptop.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={446}
                height={423}
              />
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Questioncta;
